var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41603 0.624037C4.21811 0.327171 3.78189 0.327171 3.58398 0.624038L0.518233 5.22265C0.296715 5.55493 0.534911 6 0.934259 6H7.06574C7.46509 6 7.70329 5.55493 7.48177 5.22265L4.41603 0.624037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41603 13.376C4.21811 13.6728 3.78189 13.6728 3.58397 13.376L0.518233 8.77735C0.296715 8.44507 0.534911 8 0.934259 8H7.06574C7.46509 8 7.70328 8.44507 7.48177 8.77735L4.41603 13.376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_1460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnSorting);
export default __webpack_public_path__ + "static/media/Column_sorting.88063cca73d4e531d861bfed88e40df6.svg";
export { ForwardRef as ReactComponent };